import Http from '@/http'

//演示接口
const librariesUrl = '/libraries.min.json';
export const librariesApi = function (params) {
    return Http.fetch(librariesUrl, params);
};

//如果要新增接口很方便
// const demoUrl = '/接口地址';
// export const demoApi = function (params) {
//   return Http.post(librariesUrl, params);
// };

//banner 信息
const bannerListUrl = '/platform/portal/banner/list';
export const bannerListApi = function (params) {
    return Http.fetch(bannerListUrl, params);
};

//获取banner位置分类
const bannerTypeListUrl = '/platform/portal/banner/type/list';
export const bannerTypeListApi = function (params) {
    return Http.fetch(bannerTypeListUrl, params);
};

//根据级别获取-人才-成果-政策-类型
const talentComBoxUrl = '/platform/portal/talent/combox';
export const talentComBoxApi = function (params) {
    return Http.fetch(talentComBoxUrl, params);
};

//获取人才-成果-政策信息集合
const talentListUrl = '/platform/portal/talent/list';
export const talentListApi = function (params) {
    return Http.fetch(talentListUrl, params);
};

const talentDetUrl = '/platform/portal/home/info/';
export const talentDetApi = function (params) {
    return Http.fetch(talentDetUrl+params);
};

//获取企业孵化分类
const incubateComBoxUrl = '/platform/portal/incubate/combox';
export const incubateComBoxApi = function (params) {
    return Http.fetch(incubateComBoxUrl, params);
};

//获取合作资源分类
const cooperateComBoxUrl = '/platform/portal/incubate/cooperate/combox';
export const cooperateComBoxApi = function (params) {
    return Http.fetch(cooperateComBoxUrl, params);
};

//获取企业孵化信息集合
const incubateListUrl = '/platform/portal/incubate/list';
export const incubateListApi = function (params) {
    return Http.fetch(incubateListUrl, params);
};

//获取关于我们一级分类
const aboutComBoxUrl = '/platform/portal/about/combox';
export const aboutComBoxApi = function (params) {
    return Http.fetch(aboutComBoxUrl, params);
};

//获取关于我们二级分类
const aboutParkComBoxUrl = '/platform/portal/about/park/combox';
export const aboutParkComBoxApi = function (params) {
    return Http.fetch(aboutParkComBoxUrl, params);
};

//根据分类获取关于我们各部分信息
const aboutListUrl = '/platform/portal/about/list';
export const aboutListApi = function (params) {
    return Http.fetch(aboutListUrl, params);
};

//新闻列表
const newsListUrl = '/platform/portal/news/list';
export const newsListApi = function (params) {
    return Http.fetch(newsListUrl, params);
};
//新闻类型列表
const newsTypeListUrl = '/platform/portal/news/type/list';
export const newsTypeListApi = function (params) {
    return Http.fetch(newsTypeListUrl, params);
};
//新闻详情
const newsDetailUrl = '/platform/portal/news/';
export const newsDetailApi = function (id) {
    return Http.fetch(newsDetailUrl+id);
};

//盟市科创飞地类型
const worldComBoxUrl = '/platform/portal/world/combox';
export const worldComBoxApi = function (params) {
    return Http.fetch(worldComBoxUrl, params);
};

//根据类型获取飞地信息
const worldDetailUrl = '/platform/portal/world/info/';
export const worldDetailApi = function (id) {
    return Http.fetch(worldDetailUrl+id);
};

//获取北京分平台页面分类
const footplateComBoxUrl = '/platform/portal/footplate/combox';
export const footplateComBoxApi = function (params) {
    return Http.fetch(footplateComBoxUrl,params);
};

//获取北京分平台页面信息
const footplateListUrl = '/platform/portal/footplate/list';
export const footplateListApi = function (params) {
    return Http.fetch(footplateListUrl,params);
};


//获取首页类型
const homeComBoxUrl = '/platform/portal/home/combox';
export const homeComBoxApi = function (params) {
    return Http.fetch(homeComBoxUrl,params);
};
//获取页头页脚
const headerFooterUrl = '/platform/portal/home/headfoot/list';
export const headerFooterApi = function (params) {
    return Http.fetch(headerFooterUrl,params);
};

//获取在孵明星企业分类
const incubateCoopComBoxUrl = '/platform/portal/home/incubate/cooperate/combox';
export const incubateCoopComBoxApi = function (params) {
    return Http.fetch(incubateCoopComBoxUrl,params);
};
//获取企业孵化信息集合
const homeIncubateListUrl = '/platform/portal/home/incubate/list';
export const homeIncubateListApi = function (params) {
    return Http.fetch(homeIncubateListUrl,params);
};
//获取首页信息列表
const homeListUrl = '/platform/portal/home/list';
export const homeListApi = function (params) {
    return Http.fetch(homeListUrl,params);
};
//获取首页新闻列表
const homeNewsListUrl = '/platform/portal/home/news/list';
export const homeNewsListApi = function (params) {
    return Http.fetch(homeNewsListUrl,params);
};
//获取首页新闻详情
const homeNewsDetailUrl = '/platform/portal/home/news/';
export const homeNewsDetailApi = function (id) {
    return Http.fetch(homeNewsDetailUrl+id);
};

//发布
const formUrl = '/platform/portal/home/form';
export const formApi = function (data) {
    return Http.post(formUrl,data);
};
